import React, { useEffect } from "react";
import styles from "@/pages/css/CreateProjectPage.module.css";

import { CreateProjectData } from "@/types/project";
import { useTranslation } from "react-i18next";
import { InputField } from "@/components/inputFields/inputFields";  

export const CreateProjectFilelds: React.FC<{
    onChange: (data: CreateProjectData) => void;
    data: CreateProjectData;
    setStepsCompleted: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ onChange, data, setStepsCompleted }) => {
    const { t } = useTranslation("CreateProjectPage");

    const titles = [
        {
            title: t("residents_initial"),
            id: "residents_initial",
            required: false
        },

        {
            title: t("vehicles_initial"),
            id: "vehicles_initial",
            required: false
        },

        {
            title: t("current_energy_production"),
            id: "current_energy_production",
            required: false
        },
        {
            title: t("residential_area_existing"),
            id: "residential_area_existing",
            required: false
        },
        {
            title: t("residental_unit_area_existing"),
            id: "residental_unit_area_existing",
            required: false
        },
        {
            title: t("commercial_area_existing"),
            id: "commercial_area_existing",
            required: false
        },
        {
            title: t("public_building_area_existing"),
            id: "public_building_area_existing",
            required: false
        },
        {
            title: t("industrial_area_existing"),
            id: "industrial_area_existing",
            required: false
        },
        {
            title: "תקן טעינה למגורים",
            id: "residential_charging_standard",
            required: false
        },
        {
            title: "תקן טעינה לשימושים אחרים",
            id: "other_uses_charging_standard",
            required: false
        }
    ];

    const handleChange = (field: keyof CreateProjectData, value: string | number | undefined, subField?: string) => {
        const newData = { ...data };
        
        if (value === '' || value === undefined || (typeof value === 'string' && isNaN(Number(value)))) {
            (newData as any)[field] = undefined;
        } else {
            (newData as any)[field] = Number(value);
        }
    
        onChange(newData as CreateProjectData);
        
        setStepsCompleted(() => {
            const requiredFields = titles
                .filter(title => title.required)
                .every(field => {
                    const val = newData[field.id as keyof CreateProjectData];
                    return val !== undefined && val !== null && !isNaN(Number(val));
                });            
            return requiredFields;
        });
    };

    useEffect(() => {
        setStepsCompleted(() => {
            const requiredFields = titles
                .filter(title => title.required)
                .every(field => {
                    const val = data[field.id as keyof CreateProjectData];
                    return val !== undefined && val !== null && !isNaN(Number(val));
                });            
            return requiredFields;
        });
    }, []);

    return <div className={styles.dataContainer}>
            <div className={styles.inputTitle}>{t("pahse2_description")}</div>
            <div className={styles.inputContainerOnePage}>
                {titles.map((title, index) => (
                        <div key={index} className={styles.titleElementComponent}>
                            <div className={styles.inputTitle}>
                                {title.required && <div className={styles.required}>*</div>}
                                {title.title}
                            </div>
                            <InputField 
                                small={true}
                                inputType="number" 
                                data={data[title.id as keyof CreateProjectData] as number} 
                                setData={(value) => handleChange(title.id as keyof CreateProjectData, value)}
                                id={title.id}
                            />
                        </div>
                ))}
            </div>
    </div>;
};